module.exports = __webpack_public_path__ + "media/images/countryrect/ne-703a7c45909e2c575b64f3698bfd2cdc.svg";